import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { Toast } from "primeng/toast";
import { NgHttpLoaderComponent } from "ng-http-loader";
import { TranslateModule } from "@ngx-translate/core";
import { ProgressBarComponent } from "./kernel/shared/modules/spinner/components/progress-bar/progress-bar.component";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
  imports: [RouterOutlet, Toast, NgHttpLoaderComponent, TranslateModule],
})
export class AppComponent {
  progressBar = ProgressBarComponent;
}
